import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import MenuIcon from '@mui/icons-material/Menu';
import { CircularProgress, IconButton } from '@mui/material';

import AppErrorMessage from '@/dmdrive/core/components/AppErrorMessage/AppErrorMessage';
import { AppLayout } from '@/dmdrive/core/constants/layout';
import { useStore } from '@/dmdrive/store';

import { LoaderWrapper, MobileControlBar, TopicRoot } from './Topic.styles';

import LeftSidebar from './LeftSidebar/LeftSidebar';
import RightSidebar from './RightSidebar/RightSidebar';
import { useTopicStore, withTopicStore } from './TopicStore';
import Viewer from './Viewer/Viewer';

interface TopicProps {
  topicId: string;
}

function Topic(props: TopicProps) {
  const { topicId } = props;
  const { layout } = useStore('appStore');
  const { error, isFetching, initTopicStore, topic, toggleLeftSidebar, toggleRightSidebar, dispose } = useTopicStore();

  useEffect(() => {
    if (!topicId) {
      return;
    }

    initTopicStore(topicId);

    return () => {
      dispose();
    };
  }, [topicId]);

  if (error) {
    return <AppErrorMessage error={error} />;
  }

  if (isFetching) {
    return (
      <LoaderWrapper>
        <CircularProgress />
      </LoaderWrapper>
    );
  }

  return (
    <TopicRoot layout={layout}>
      {layout === AppLayout.Mobile && (
        <MobileControlBar>
          {topic?.isDMIndustrial && (
            <IconButton size="small" onClick={() => toggleLeftSidebar(true)}>
              <MenuIcon fontSize="small" />
            </IconButton>
          )}

          <IconButton size="small" onClick={() => toggleRightSidebar(true)}>
            <MenuIcon fontSize="small" />
          </IconButton>
        </MobileControlBar>
      )}

      {topic?.isDMIndustrial && <LeftSidebar />}

      <Viewer />

      <RightSidebar />
    </TopicRoot>
  );
}

export default withTopicStore(observer(Topic));
